import {IFacilityType} from '../pages/generate-report/types';

// types.ts
export type GeographyFilterOptions = {
    county_additional_info: {
        county_name: string;
        county_ssa: string;
        county_designation: string;
        fips: string;
        mapbox_id: string;
        state: string;
        year_key: number;
    };
    county_dim_key: string;
    patient_network_population: string;
    run_id: string;
    ssacd: string;
    standard_type: string;
    patient_roster_id: string;
    patient_roster_name: string;
    standard_version: string;
    state: string;
    state_additional_info: {
        bbox: number[];
        code: string;
        mapbox_id: string;
        state: string;
        state_ssa: string;
    };
};

export type AppliedGeographyFilter = {
    state: string;
    county: string;
    standard_type: string;
    patient_roster_name: string;
    standard_version: string;
};

export type DisruptionAnalysisFilterOptions = {
    county_additional_info: {
        county_name: string;
        county_ssa: string;
        county_designation: string;
        fips: string;
        mapbox_id: string;
        state: string;
        year_key: number;
    };
    ssacd: string;
    standard_type: string;
    patient_roster_id: string;
    patient_roster_name: string;
    state: string;
    zip: string;
    state_additional_info: {
        bbox: number[];
        code: string;
        mapbox_id: string;
        state: string;
        state_ssa: string;
    };
};

export type AppliedDisruptionAnalysisFilter = {
    state: string;
    county: string;
    standard_type: string;
    patient_roster_name: string;
    zip: string;
};

export type ComplianceScore = any; 
export type RunId = number;

export type FetchGeoJsonResponse = GeoJSON.FeatureCollection; 
export type FetchProvidersResponse = any[];
export type FetchComplianceResponse = Array<any>;
export type FetchRunIdResponse = number | null;

export const DISTANCE_CALC_TYPES = [
    {name: 'Drivetime', value: 'actual'},
    {name: 'Physical', value: 'euclidean'},
];

export type SortOrderItem = {
    direction: 'ASC' | 'DESC' | 'NONE';
    column_name: string;
};

export interface IGeographyFilterPayload {
    state: string;
    county: string;
    standard_version: string;
    standard_type: string;
    patient_roster_id: string;
}

export interface IDisruptionAnalysisFilterPayload {
    state: string;
    county: string;
    standard_version?: string;
    standard_type: string;
    patient_roster_id: string;
    zip: string;
}

export interface IFetchReportsPayload {
    roster_id: number;
    revision_id: number;
    signal: AbortSignal;
    standard_type: string;
    standard_version: string;
    patient_roster_id: number;
    state?: string[];
    county?: string[];
    specialty_code: string[];
    limit?: number;
    page?: number;
    order_by?: SortOrderItem;
}

export enum StandardType {
    QHP = 'QHP',
    MA = 'MA',
}

export interface IFetchSpecialtyGroupingPayload {
    roster_id: number; 
    standard_type: string; 
    standard_version: string;
    specialty_code: string[];
    signal: AbortSignal;
}

export interface IFetchMaxTimeDistPayload {
    roster_id: number; 
    revision_id: number;
    standard_type: string; 
    standard_version: string;
    specialty_code: string[];
    signal: AbortSignal;
}

export type IFetchAvgTimeDistPayload = IFetchMaxTimeDistPayload & {
    provider_facility_type: IFacilityType;
};

export type IFetchSpecialtyStdsByCountyPayload = IFetchMaxTimeDistPayload & {
    state?: string
};

export type IFetchSpecialtyStdsByCountyBatchPayload = IFetchMaxTimeDistPayload & {
    state: string[];
    county: string[];
};